import {
  AnimationAnimateMetadata,
  AnimationBuilder,
  AnimationStyleMetadata,
  animate,
  style
} from '@angular/animations';
import {
  ANIMATION_TRANSLATE_Y,
  AnimationDirection,
  AnimationDuration,
  AnimationScaleRatio
} from './label-animation.directive.enum';

export function labelStyleInit(dir: AnimationDirection, animationBuilder: AnimationBuilder, div: unknown) {
  const initialLabelStyle = [
    style({
      transformOrigin: dir,
      transform: `scale(${AnimationScaleRatio.LARGE_PARTIAL_SCALE}) translateY(${ANIMATION_TRANSLATE_Y})`
    })
  ];
  const animation = animationBuilder.build(initialLabelStyle);
  const player = animation.create(div);
  player.play();
}

export function initAnimations(
  originDir: string,
  toTopAnimation: (AnimationStyleMetadata | AnimationAnimateMetadata)[],
  toBottomAnimation: (AnimationStyleMetadata | AnimationAnimateMetadata)[],
  animationBuilder: AnimationBuilder,
  isStart: boolean,
  div: unknown
): void {
  toTopAnimation = [
    animate(
      AnimationDuration.SHORT,
      style({
        transformOrigin: originDir,
        transform: `translateY(${ANIMATION_TRANSLATE_Y})`, // scale(${AnimationScaleRatio.LARGE_PARTIAL_SCALE})
        fontSize: '10px',
        textWrap: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '95%'
      })
    )
  ];

  toBottomAnimation = [
    animate(
      AnimationDuration.SHORT,
      style({
        transformOrigin: originDir,
        transform: `scale(1) translateY(0)`,
        overflow: 'visible',
        textWrap: 'wrap',
        textOverflow: 'unset',
        fontSize: '14px',
        width: 'unset'
      })
    )
  ];

  const animation = animationBuilder.build(isStart ? toTopAnimation : toBottomAnimation);
  const player = animation?.create(div);
  player.play();
}
